import { APP_AUTH_ACCESS_KEY, APP_AUTH_REFRESH_KEY, APP_AUTH_USER } from '@app/constant/constant'
import { getLocal, removeLocal } from './storage-available'

export const getAuthUser = () => {
  try {
    const data = getLocal(APP_AUTH_USER)
    if (data) {
      return JSON.parse(data)
    }
    return null
  } catch (error) {
    return null
  }
}

export const getAuthAccess = () => {
  try {
    return getLocal(APP_AUTH_ACCESS_KEY)
  } catch (error) {
    return null
  }
}
export const getAuthRefresh = () => {
  try {
    return getLocal(APP_AUTH_REFRESH_KEY)
  } catch (error) {
    return null
  }
}

export const appLogout = async () => {
  removeLocal(APP_AUTH_ACCESS_KEY)
  removeLocal(APP_AUTH_REFRESH_KEY)
  removeLocal(APP_AUTH_USER)
}
